import { Component, Input } from '@angular/core';
import { AlarmHistoryData } from 'ops/common/models/alarm-history-data';

@Component({
    selector: 'app-alarm-history-detail-overlay',
    templateUrl: './alarm-history-detail-overlay.component.html',
    styleUrls: [
        './alarm-history-detail-overlay.component.css',
        '../alarm-monitoring-detail-overlay/alarm-monitoring-detail-overlay.component.css',
    ],
    standalone: false
})
export class AlarmHistoryDetailOverlayComponent {
    @Input() alarm: AlarmHistoryData;

    style = {
        display: 'none',
    };

    public setVisible(visible: boolean) {
        this.style.display = visible ? 'flex' : 'none';
    }
}
